/**
 * @file PayFrequencyDropdown.js
 * @description A dropdown component for selecting a pay frequency.
 */

import React, { useState, useEffect } from "react";
import { fetchPayFrequencies } from "../../../services/systemService";
import { Dropdown } from "../../helpers/Dropdown";
import LoadingWrapper from "../../ui/loaders/LoadingWrapper";
import Toast from "../../ui/toasts/Toast";
import { getText } from '../../../i18n';

const PayFrequencyDropdown = ({
  className,
  inlineLabel = true,
  selectedFrequency,
  onFrequencyChange,
  required = false,
}) => {
  const [frequencies, setFrequencies] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getPayFrequencies = async () => {
      setIsLoading(true);
      try {
        const data = await fetchPayFrequencies();
        setFrequencies(data);
      } catch (error) {
        console.error("Could not fetch pay frequencies:", error);
        Toast.error(getText('msg_d31229952a39'));
      } finally {
        setIsLoading(false);
      }
    };

    getPayFrequencies();
  }, []);

  const getDefaultLabel = () => {
    const matchingFrequency = frequencies.find(
      (frequency) => frequency.id === selectedFrequency
    );
    return matchingFrequency ? matchingFrequency.name : "Select Pay Frequency";
  };

  const frequencyOptions = [
    { value: null, label: getText('msg_e178ad13471b') },
    ...frequencies.map((format) => ({
      value: format.id,
      label: format.name,
    })),
  ];

  return (
    <div
      className={`form-group mb-3 ${
        inlineLabel ? "inline-input" : ""
      } ${className}`}
    >
      <label htmlFor="frequency-dropdown">{getText('msg_9f5a370f9db2')}{required && <span className="text-danger">*</span>}</label>
      <LoadingWrapper isLoading={isLoading}>
        <Dropdown
          id="frequency-dropdown"
          defaultValue={getDefaultLabel()}
          options={frequencyOptions}
          value={selectedFrequency}
          onChange={onFrequencyChange}
          disabled={frequencies.length === 0 || isLoading}
        />
      </LoadingWrapper>
    </div>
  );
};

export default PayFrequencyDropdown;
